

import { mapState } from 'vuex'
import ProductListingItem from '@/components/catalog/ProductListingItem'

export default {
  components: {
    ProductListingItem
  },
  hardLimit: 400,
  computed: {
    ...mapState('catalog', {
      products: state => state.products,
      pages: state => state.pages,
      total: state => state.total
    }),

    page: {
      get () {
        const { page } = this.$route.query

        if (typeof page !== 'string') {
          return 1
        }

        const parsedPage = parseInt(page)

        return isNaN(parsedPage) ? 1 : parsedPage
      },
      async set (page) {
        await this.$router.push({ query: { ...this.$route.query, page } })
        window.scroll(0, 0)
      }
    }
  },
  watch: {
    // Run whenever pagination renders
    page () {
      this.$nextTick(this.disablePages)
    },
    totalPages () {
      this.$nextTick(this.disablePages)
    }
  },
  mounted () {
    this.disablePages()
  },

  methods: {
    linkToPdp (product) {
      let to = this.localePath({
        name: 'catalog-product-id',
        params: { id: product.entityId }
      })
      if ('slug' in product) {
        to = '/' + product.slug
      }
      return to
    },

    disablePages () {
      try {
        const el = this.$refs.pagination?.$el
        if (!el) {
          return
        }

        const buttons = el.querySelectorAll('.v-pagination__item')
        buttons.forEach((btn) => {
          const label = btn.getAttribute('aria-label') || ''
          const match = label?.toLowerCase().match(/goto page (\d+)/)

          if (match) {
            const num = parseInt(match[1], 10)
            if (num > this.$options.hardLimit) {
              btn.setAttribute('disabled', 'true')
              btn.style.pointerEvents = 'none'
              btn.style.opacity = '0.4'
              btn.style.cursor = 'not-allowed'
            } else {
              btn.removeAttribute('disabled')
              btn.style.pointerEvents = ''
              btn.style.opacity = ''
              btn.style.cursor = ''
            }
          }
        })

        const nextButton = el.querySelector('.v-pagination__navigation[aria-label="Next page"]')
        if (nextButton) {
          if (this.page >= this.$options.hardLimit) {
            nextButton.setAttribute('disabled', 'true')
            nextButton.style.pointerEvents = 'none'
            nextButton.style.opacity = '0.4'
            nextButton.style.cursor = 'not-allowed'
          } else {
            nextButton.removeAttribute('disabled')
            nextButton.style.pointerEvents = ''
            nextButton.style.opacity = ''
            nextButton.style.cursor = ''
          }
        }
      } catch (e) {
        console.error('Error while securing paging', e)
      }
    }
  }
}
